import React, { useEffect, useRef } from 'react'
import debounce from 'lodash.debounce';

interface Props {
    className?: string;
    min?: number;
    max?: number;
    step?: number;
    range?: number[];
    defaultValue?: number | undefined | string;
    dragStrictly?: boolean;
    onChange?: (value: number) => void;
    // onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}


export const FinanceSlider: React.FC<Props> = ({
    className = "",
    min = 0,
    max = 100,
    step = 1,
    range = [],
    defaultValue = 0,
    dragStrictly = false,
    onChange = () => { }
}) => {
    const ref = useRef<HTMLInputElement>(null);

    const handleValueChange = debounce(onChange, 300);

    useEffect(() => {
        if (ref.current && defaultValue) {
            ref.current.value = defaultValue.toString();
        }
    }, [defaultValue])


    const handleSliderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = parseInt(e.currentTarget.value);
        handleValueChange(newValue);
    };

    if (range.length > 0) {
        min = range[0];
        max = range[range.length - 1];

        step = range[1] - range[0];
    } else {
        range = Array.from(Array((max - min) / step + 1).keys()).map((_, i) => min + i * step);
    }


    return (
        <div className={`relative w-full ${className}`}>
            <input
                ref={ref}
                type="range"
                min={min}
                max={max}
                step={!dragStrictly ? 1 : step}
                defaultValue={defaultValue}
                // onChange={(e) => onChange(parseInt(e.target.value))}
                onChange={handleSliderChange}
                className="w-full h-1 bg-custom-200 rounded-full outline-none appearance-none accent-red-600"
            />

            <div className="flex justify-between mt-4">
                {range.map((value, index) => (
                    <div
                        key={index}
                        className={` dark:text-white text-sm ${index === 0 ? "text-left" : index === range.length - 1 ? "text-right" : "text-center"}`}
                    >
                        {value > 1000 ? `${value / 1000}k` : value}
                    </div>
                ))}
            </div>
        </div>
    );
}